const VERSION_PATTERN = /^\d+(\.\d+)*$/;

/**
 * Parses a dotted numeric version ("1.9.10") into its segments. Anything that
 * is not a string of dot-separated integers yields null.
 */
export function parseVersion(raw: unknown): number[] | null {
  if (typeof raw !== 'string') return null;
  const trimmed = raw.trim();
  if (!VERSION_PATTERN.test(trimmed)) return null;
  return trimmed.split('.').map(Number);
}

function compareSegments(a: number[], b: number[]): number {
  const length = Math.max(a.length, b.length);
  for (let i = 0; i < length; i++) {
    const left = a[i] ?? 0;
    const right = b[i] ?? 0;
    if (left !== right) return left > right ? 1 : -1;
  }
  return 0;
}

/**
 * True only when both versions parse and `candidate` is numerically newer than
 * `current`. Garbage on either side never reports an update.
 */
export function isNewerVersion(candidate: unknown, current: unknown): boolean {
  const candidateSegments = parseVersion(candidate);
  const currentSegments = parseVersion(current);
  if (!candidateSegments || !currentSegments) return false;
  return compareSegments(candidateSegments, currentSegments) > 0;
}
